module.exports = __webpack_public_path__ + "static/media/bookmark.5e4da794.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bookmark.svg
// module id = 851
// module chunks = 0